<script>
    export let title;
    export let hint;
    export let align;
    export let icon;
</script>
<div class={`title ${align}`}>
    <div class="title-block">
        {#if (icon)}
            <img class="icon" src={icon}/>
        {/if}
        <h4>{title}</h4>
    </div>
    <div class="hint">{hint}</div>
</div>

<style>
    h4 {
        margin: 0;
        font-weight: 600;
        font-size: 15px;
        line-height: 21px;
        color: #020202;
    }

    .hint {
        margin-top: 4px;
        white-space: nowrap;
        font-weight: 400;
        transform: scale(calc(10 / 12));
        font-size: 12px;
        color: #333333;
        letter-spacing: 0;
    }

    .title-block {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .title.left .title-block {
        justify-content: flex-start;
        padding-left: 14px;
    }

    .icon {
        width: 20px;
        display: inline-block;
    }
</style>
